import { 
    GET_ADDRESSES_WITH_PREFIX_SUCCESS,
    GET_ADDRESSES_WITH_PREFIX_FAILED,
    GET_CONTACTS_WITH_PREFIX_SUCCESS,
    GET_CONTACTS_WITH_PREFIX_FAILED,
} from '../constants/elasticsearchConstants';

export function successGetAddressesWithPrefix(src, data) {
    return {
        type: GET_ADDRESSES_WITH_PREFIX_SUCCESS,
        payload: {
            addresses: data,
            src: src
        }
    };
}

export function failedGetAddressesWithPrefix(error) {
    return {
        type: GET_ADDRESSES_WITH_PREFIX_FAILED,
        payload: 'Unable to get addresses with prefix. Error:' + error,
    };
}

export function successGetContactsWithPrefix(src, data) {
    return {
        type: GET_CONTACTS_WITH_PREFIX_SUCCESS,
        payload: {
            contacts: data,
            src: src
        }
    };
}

export function failedGetContactsWithPrefix(error) {
    return {
        type: GET_CONTACTS_WITH_PREFIX_FAILED,
        payload: 'Unable to get contacts with prefix. Error:' + error,
    };
}



// WEBPACK FOOTER //
// ./src/state/actions/elasticsearchActions.js